<p-table [value]="courseStartDates">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + KIL?.toLocaleLowerCase()">
      <th class="table__header--uppercase">
        {{ columnLabels.title }}
      </th>
      <th>{{ columnLabels.courseLength }}</th>
      <th>{{ columnLabels.courseBreak }}</th>
      <th>{{ columnLabels.startDates }}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr>
      <td>{{ data.course }}</td>
      <td>{{ data.tuitionLength ?? '-' }}</td>
      <td>{{ data.courseBreak ?? '-' }}</td>
      <td>{{ data.startDates ?? '-' }}</td>
    </tr>
  </ng-template>
</p-table>
